module.exports = __webpack_public_path__ + "static/media/bicycles_hero_desktop.5e49b1a7.jpg";